import React, { FC } from "react";
import useTranslation from "next-translate/useTranslation";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";

import { CALENDLY_LINK_PRODUCT_DEMO } from "@/constants/pricing";
import { LinkButton } from "@/components/LinkButton";
import { Image } from "@/components/Image";
import { IImage } from "@/typings/common";

interface ISolutionsForAgenciesVideoSection {
  title: string;
  subtitle: string;
  image: IImage;
}

export const SolutionsPageTopSection: FC<ISolutionsForAgenciesVideoSection> = ({
  title,
  subtitle,
  image,
}) => {
  const { bp, colors } = useTheme();
  const { css } = useFela();
  const { t } = useTranslation();

  return (
    <Grid
      background="NAVY"
      customStyle={{
        flexDirection: "column",
        alignItems: "center",
        [bp.FROM_DESKTOP]: {
          flexDirection: "row",
          padding: "130px 20px 158px",
        },
      }}
      wrapperStyle={{
        background: `linear-gradient(84deg, ${colors.GRADIENT_BLUE_DARK} -32%, ${colors.GRADIENT_PURPLE} 94%)`,
      }}
      id="SolutionsForAgenciesVideoSection"
    >
      <div
        className={css({
          marginBottom: 40,
          flexShrink: 2,
          [bp.FROM_DESKTOP]: { marginBottom: 0 },
        })}
      >
        <Heading
          as="h1"
          customStyle={{
            color: colors.WHITE,
            textAlign: "left",
            [bp.FROM_DESKTOP]: {
              fontSize: 64,
              lineHeight: "74px",
              letterSpacing: "-1%",
            },
          }}
        >
          {title}
        </Heading>
        <p
          className={css({
            maxWidth: "80%",
            color: colors.WHITE,
            marginBottom: 40,
          })}
        >
          {subtitle}
        </p>
        <LinkButton
          href={CALENDLY_LINK_PRODUCT_DEMO}
          target="_blank"
          customStyle={{ maxWidth: 190 }}
          title={t("common:scheduleDemo")}
        />
      </div>
      <Image
        customStyle={{ maxWidth: 327, width: "100%" }}
        wrapperStyle={{ width: "40%", flexShrink: 1 }}
        {...image}
      />
    </Grid>
  );
};
